import React from 'react';
import ContainedImage from '../../../elements/ContainedImage';
import styles from './Header.module.scss';

export default class Header extends React.Component {
    render() {
        return (
            <div className={styles.header}>
                <ContainedImage className={styles.background} src={this.props.background}   />
                <ContainedImage className={styles.icon} src={this.props.icon}  />
            </div>
        );
    }
}
